module.exports = __webpack_public_path__ + "static/media/www.enchanting-costarica.com.867c1988.jpg";